import { forwardRef } from "react";
import type { EquiplyIconProps, EquiplyIcon } from "../types";

/** Archive — boîte avec couvercle duotone */
export const ArchiveIcon: EquiplyIcon = forwardRef<SVGSVGElement, EquiplyIconProps>(
  ({ size = 24, ...props }, ref) => (
    <svg ref={ref} width={size} height={size} viewBox="0 0 24 24" fill="none" {...props}>
      {/* Couvercle menthe */}
      <rect x="3" y="4" width="18" height="5" rx="1.5" fill="var(--equiply-icon-bg)" />
      <rect x="3" y="4" width="18" height="5" rx="1.5" stroke="var(--equiply-icon-fg)" strokeWidth="1.5" />
      {/* Corps */}
      <path
        d="M4.5 9v9.5A1.5 1.5 0 0 0 6 20h12a1.5 1.5 0 0 0 1.5-1.5V9"
        stroke="var(--equiply-icon-fg)" strokeWidth="1.5" strokeLinejoin="round"
      />
      {/* Encoche */}
      <path d="M10 13h4" stroke="var(--equiply-icon-fg)" strokeWidth="1.75" strokeLinecap="round" />
    </svg>
  ),
);
ArchiveIcon.displayName = "ArchiveIcon";
